pdfHandler = {
    $downloadButton = $('.download-button'),
    $html = $('html'),
    $footer = $('footer'),
    gifImages = [],
         
    init = function(){
        var self = this;
        $('body.single img').each(function(index, img_tag) {
            if (/.*\.gif/.test(img_tag.src)) {
                $(img_tag).parent().css({'position': 'relative'});
                var $cloned = $(img_tag).clone();
                $cloned.css({
                    'position': 'absolute',
                    'left': 0,
                    'top': 0,
                    'width': '100%',
                    'height': '100%',
                    'z-index': -1,
                });
                $cloned.appendTo($(img_tag).parent());
                self.gifImages.push(new SuperGif({ 
                    gif: $cloned.get(0),
                    progressbar_foreground_color: '#FFCC00',
                    progressbar_background_color: 'rgba(255,255,255,0)',
                }));
                self.gifImages[self.gifImages.length-1].load();
            }
        })
            
        this.$downloadButton.on('click', function(){
            var filename     = $(this).data('filename');
            var initialWidth = self.$html[0].offsetWidth; 
            var sheetWidth   = 1587;//px == 420mm 
            var addonHeight = -17; 
            self.$html.addClass('print-mode');
            var $body        = self.$html.find('body')[0];

            for (var i=0; i<self.gifImages.length; i++) {
                self.gifImages[i].move_to(0);
                self.gifImages[i].pause();
            }

            if (initialWidth < 1440) {
                addonHeight = 55;
            } else {
                addonHeight = -10;
            }

            if (initialWidth <= 1366) {
                var addon = 115;

                if (initialWidth <= 1152) {
                    addon = ((1366 - initialWidth) * 1.2);
                }

                if (initialWidth <= 1024) {
                    addon = ((1366 - initialWidth) * 0.7) - ((1024 - initialWidth) * 0.8); 
                }

                if (initialWidth <= 768) {
                    addon = 210;
                }

                addonHeight = addon + ((1366 - initialWidth) * 2);

                if (initialWidth < 640) {
                    addon = 1350;
                    if (initialWidth < 420) {
                        addon = 1340;
                    }
                    if (initialWidth < 413) {
                        addon = 1365;
                    }
                    if (initialWidth <= 320) {
                        addon = 1100;
                    }
                    addonHeight = addon + ((640 - initialWidth) * 1.7);
                }
            }
            
            var sheetHeight = Math.max($body.scrollHeight, $body.offsetHeight) + addonHeight;

            if (!filename) {
                filename = 'untitled.pdf'
            } 
            
            var opt = {
                margin:       1,
                filename:     filename,
                image:        { type: 'jpeg', quality: 1.0 },
                html2canvas:  { 
                                backgroundColor: '#000000',
                                dpi: 300, 
                                letterRendering: true, 
                                useCORS: true, 
                              }, 
                jsPDF:        { unit: 'px', format: [sheetHeight, sheetWidth], orientation: 'portrait' },
            };
            html2pdf().from($body).set(opt).save().then(function(){
                self.$html.removeClass('print-mode');  
            });       
        });
    }
}
